<script lang="ts">
  import { Button } from '../common';
  import type { RuleSuggestion } from '../../types/transaction';

  let {
    suggestion,
    creating = false,
    onCreate,
    onCreateAndApply,
    onDismiss
  }: {
    suggestion: RuleSuggestion;
    creating?: boolean;
    onCreate: () => void;
    onCreateAndApply: () => void;
    onDismiss: () => void;
  } = $props();
</script>

<div class="rule-toast">
  <button class="close-btn" onclick={onDismiss} aria-label="Close">×</button>
  <div class="toast-header">
    <strong>Create a rule?</strong>
  </div>
  <div class="toast-content">
    <div class="pattern-preview">
      <span class="pattern">"{suggestion.pattern}"</span>
      <span class="arrow">→</span>
      <span class="category">{suggestion.category}</span>
      {#if suggestion.person}
        <span class="person">({suggestion.person})</span>
      {/if}
    </div>
  </div>
  <div class="toast-actions">
    <Button variant="success" size="sm" onclick={onCreateAndApply} disabled={creating}>
      {creating ? 'Creating...' : 'Create & Apply'}
    </Button>
    <Button variant="primary" size="sm" onclick={onCreate} disabled={creating}>
      Create
    </Button>
  </div>
</div>

<style lang="scss">
  @keyframes slideInFromRight {
    from {
      opacity: 0;
      transform: translateX(100%);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  .rule-toast {
    position: relative;
    background: white;
    border-radius: var(--radius-xl);
    box-shadow: var(--shadow-3xl);
    max-width: 420px;
    width: calc(100vw - 48px);
    animation: slideInFromRight 0.3s ease-out;
  }

  .close-btn {
    position: absolute;
    top: 16px;
    right: 16px;
    background: transparent;
    border: none;
    color: var(--color-text-muted);
    font-size: var(--font-size-2xl);
    line-height: var(--line-height-none);
    cursor: pointer;
    padding: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--spacing-xs);
    transition: all var(--transition-fast);
    z-index: 1;

    &:hover {
      background: var(--color-background-tertiary);
      color: var(--color-text-tertiary);
    }
  }

  .toast-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--spacing-lg) var(--spacing-lg) var(--spacing-md) var(--spacing-lg);
    border-bottom: 1px solid var(--color-border);

    strong {
      font-size: var(--font-size-sm);
      color: var(--color-text-primary);
    }
  }

  .toast-content {
    padding: var(--spacing-md) var(--spacing-lg);

    .pattern-preview {
      display: flex;
      align-items: center;
      gap: var(--spacing-sm);
      background: var(--color-background-secondary);
      padding: var(--spacing-md) 12px;
      border-radius: var(--radius-md);
      font-size: var(--font-size-sm);
      flex-wrap: wrap;

      .pattern {
        font-weight: var(--font-weight-semibold);
        font-family: monospace;
        color: var(--color-text-primary);
      }

      .arrow {
        opacity: 0.5;
        color: var(--color-text-tertiary);
      }

      .category {
        background: var(--color-primary-bright);
        color: white;
        padding: 3px 10px;
        border-radius: var(--spacing-xs);
        font-weight: var(--font-weight-semibold);
        font-size: var(--font-size-xs);
      }

      .person {
        color: var(--color-text-tertiary);
        font-size: var(--font-size-xs);
      }
    }
  }

  .toast-actions {
    display: flex;
    gap: var(--spacing-sm);
    padding: var(--spacing-md) var(--spacing-lg) 16px 16px;

    :global(.btn) {
      flex: 1;
    }
  }
</style>
